// extracted by mini-css-extract-plugin
export default {"faqArticle":"FaqArticle_faqArticle__jfQ1u","faqArticleBar":"FaqArticle_faqArticleBar__KvsVc","topBar":"FaqArticle_topBar__gY-Ox"};